import { getAccessTokenFromStorage } from './session-store'
import { syncAllData } from './offline-data-sync'
import { markDeviceProvisioned } from './device-provision-meta'
import { getProvisionOrganizationIdFromEnv } from './offline-provision-config'
import { saveInitSnapshot } from './init-snapshot'
import { getOfflineUsers } from './offline-users-store'

/**
 * Sync completo per wizard provisioning + snapshot init + meta dispositivo.
 * @param {{ provisionedByRole?: number, provisionedOrganizationIds?: number[], organizationIdForConfig?: number | null }} [options]
 * @returns {Promise<{ success: boolean, results?: object, importStats?: object, loginUsersCount?: number, reason?: string, error?: string }>}
 */
export async function runDeviceProvisioningSync(options = {}) {
  const token = getAccessTokenFromStorage()
  if (!token) {
    return { success: false, reason: 'no_token' }
  }

  const organizationIdForConfig =
    options.organizationIdForConfig !== undefined
      ? options.organizationIdForConfig
      : getProvisionOrganizationIdFromEnv()

  const syncResult = await syncAllData({ organizationIdForConfig })
  if (!syncResult.success) {
    return syncResult
  }

  try {
    const raw = localStorage.getItem('adams_user')
    const adamsUser = raw ? JSON.parse(raw) : null
    if (adamsUser?.init) {
      await saveInitSnapshot(adamsUser.init)
    }
  } catch {
    /* ignore */
  }

  const provisionedOrgIds =
    organizationIdForConfig != null
      ? [organizationIdForConfig]
      : options.provisionedOrganizationIds

  await markDeviceProvisioned({
    provisionedByRole: options.provisionedByRole,
    provisionedOrganizationIds: provisionedOrgIds,
    provisionOrganizationIdForConfig: organizationIdForConfig ?? null
  })

  const loginUsersCount = (await getOfflineUsers()).length

  return {
    ...syncResult,
    loginUsersCount,
    importStats: syncResult.results?.userImportStats
  }
}
